export const cs = {
  appName: 'NextinQ',
  enums: {
    sharingInfo: {
      fullName: 'Celé jméno',
      email: 'Email',
      phoneNumber: 'Telefon'
    },
    wsConnectionStatus: {
      connecting: 'probíhá připojování ...',
      error: 'Chyba spojení'
    }
  },
  auth: {
    emailLead: 'Zadejte svůj email, pošleme Vám přihlašovací kód',
    emailPlaceholder: 'vas@email.cz',
    continue: 'Pokračovat',
    sending: 'Odesílání ...',
    // Deliberately neutral: the server does not confirm whether the account
    // exists, so the text must not imply it either.
    codeLead: 'Pokud email %{email} známe, poslali jsme na něj šestimístný kód',
    signIn: 'Přihlásit se',
    verifying: 'Ověřování ...',
    signingIn: 'Přihlašování ...',
    signInAgain: 'Přihlásit se znovu',
    changeEmail: 'Změnit email',
    errors: {
      invalidEmail: 'Nesprávný formát emailu',
      tooManyRequests: 'Příliš mnoho pokusů, zkuste to prosím později',
      requestFailed: 'Kód se nepodařilo odeslat, zkuste to prosím znovu',
      emailDeliveryFailed: 'Email se nepodařilo doručit, zkuste to prosím znovu',
      invalidCode: 'Nesprávný kód',
      expiredCode: 'Platnost kódu vypršela, nechte si poslat nový',
      tooManyAttempts: 'Příliš mnoho pokusů, nechte si prosím poslat nový kód',
      invalidToken: 'Neočekávaná chyba, zkuste prosím akci zopakovat',
      invalidOrExpiredToken: 'Platnost přihlášení vypršela, přihlaste se prosím znovu',
      unknownError: 'Neočekávaná chyba, zkuste prosím akci zopakovat'
    }
  },
  buttons: {
    ok: 'Ok',
    signOut: 'Odhlásit se',
    enterPIN: 'Mám lístek',
    checkIn: 'Chci lístek',
    addProvider: 'Přidat poskyt.',
    next: 'Další',
    remoteCheckin: 'Zařadit se',
    updateProfile: 'Upravit profil',
    leaveQueue: 'Opustit frontu',
    saveProfile: 'Uložit profil'
  },
  successes: {
    userProfileUpdated: 'Váš profil byl uložen',
    providerCodeEntered: 'Poskytovatel byl přidán do Vašich služeb'
  },
  errors: {
    invalidEmail: 'Nesprávný formát emailu',
    invalidPhone: 'Nesprávný formát tel. čísla',
    fullNameMinLength: 'Jméno je příliš krátké',
    fullNameMaxLength: 'Jméno je příliš dlouhé (max. 30 znaků)',
    invalidCode: 'Nesprávný kód poskytovatele služby',
    invalidPIN: 'Nesprávný pin lístku',
    serverError: 'Neočekávaná chyba, zkuste prosím akci zopakovat',
    unknownError: 'Neočekávaná chyba, zkuste prosím akci zopakovat',
    invalidQueueId: 'Neočekávaná chyba, zkuste prosím akci zopakovat',
    queueClosed: 'Fronta je zavřená',
    /*
     * One key per code the server can send — see the `failure(...)` calls in
     * packages/server/src/ws/mobile.ts. A code with no key here falls through
     * polyglot's `_` fallback to unknownError, which is how "you have used up
     * today's check-ins" and "that PIN does not exist" ended up reading
     * identically. The three `err*` names these replace were the old qcloud
     * vocabulary and no longer correspond to anything the server emits.
     */
    remoteCheckinDisabled:
      'Poskytovatel nepovolil pro tuto frontu vzdálené přihlášení',
    tooManyCheckins:
      'Překročili jste povolený počet vzdálených přihlášení za den do této fronty',
    invalidTicketId: 'Tento lístek už ve frontě není',
    notYourTicket: 'Tento lístek nepatří Vám',
    alreadyCheckedIn: 'V této frontě už lístek máte',
    ticketAlreadyClaimed: 'Tento lístek už je přiřazený jinému účtu',
    tooManyAttempts: 'Příliš mnoho pokusů, zkuste to prosím později',
    internalError: 'Neočekávaná chyba, zkuste prosím akci zopakovat',
    unknownCommand: 'Neočekávaná chyba, zkuste prosím akci zopakovat'
  },
  screen: {
    registerQueue: {
      title: 'Kód poskytovatele'
    },
    registerTicket: {
      title: 'Zadejte PIN lístku'
    },
    userProfile: {
      title: 'Můj profil'
    },
    sharingInfo: {
      title: 'Zařadit se'
    },
    remoteCheckin: {
      title: 'Zařadit se'
    },
    leaveQueue: {
      title: 'Skutečně opustit frontu?',
      message1: 'Po opuštění fronty pozbývá lístek platnosti',
      message2:
        'Opuštěním fronty nám pomáháte urychlit odbavení ostatních zákazníků - děkujeme.'
    },
    error: {
      title: 'Chyba připojení',
      info: 'Bohužel se nemůžeme spojit s naším serverem',
      actionInfo: 'Zkontrolujte připojení k internetu a zkuste to znovu',
      tryAgain: 'Zkusit znovu'
    },
    sharingInfoScreen: {
      infoText1: 'Vyberte prosím údaje, které chcete zobrazit poskytovateli',
      infoText2: 'Můžete tím urychlit Vaše odbavení.',
      completeUserProfileInfo:
        'Abyste mohli sdílet všechny údaje, dokončete prosím nastavení Vašeho profilu',
      gotoProfile: 'Upravit můj profil'
    },
    remoteCheckinScreen: {
      summary: 'Zařadit se do fronty na tuto službu',
      sharingInfoTitle: 'souhlasíte s poskytnutím těchto Vašich údajů:',
      noSharedItems: 'Neposkytovat této službě žádné údaje - anonymní zařazení'
    }
  },
  titles: {
    myQueues: 'Moje služby',
    checkedQueues: 'Moje zařazení'
  },
  statuses: {
    queueStatus: {
      open: 'Otevřeno',
      closed: 'Zavřeno',
      disconnected: 'Odpojeno'
    },
    queueInfo: {
      servedNow: 'Jste na řadě, vstupte prosím',
      overdue: 'Už jste byl(a) volán(a), vstupte prosím',
      peopleInQueue: {
        smartCount:
          'Čeká tu jen 1 člověk |||| Čekají tu %{smart_count} lidé |||| Čeká tu %{smart_count} lidí',
        zero: 'Čekárna je prázdná'
      },
      peopleInFrontOfMe: {
        zero: 'Jste další na řadě, vyčkejte na vyzvání prosím',
        smartCount:
          'Jen %{smart_count} člověk čeká před Vámi |||| Jen %{smart_count} lidé čekají před Vámi |||| %{smart_count} lidí čeká před Vámi'
      },
      onePersonInQueue: 'Čeká tu jen 1 člověk',
      queueEmpty: 'Čekárna je prázdná'
    }
  },
  components: {
    userProfile: {
      email: 'Email',
      fullName: 'Celé jméno',
      phoneNumber: 'Telefon'
    },
    dialCodeSelector: {
      selectCodeTitle: 'Vyberte předčíslí'
    },
    userProfileButton: {
      myProfile: 'Můj profil'
    }
  }
};
